import { Pipe, PipeTransform } from '@angular/core';
import { CommissionType } from '../constants/commission-types';

@Pipe({
  name: 'fundCommisionType'
})
export class FundCommisionTypePipe implements PipeTransform {

  transform(value: unknown): unknown {
       const commisionTypes = CommissionType.types;
       const found = commisionTypes.find(e => e.value === value);
       if (found) {
         return found.name;
       }
       return '-';
  }

}
